import { observable, computed, action, makeObservable } from 'mobx';

class SchedulleStore {
    isOpen;
    isSaleSchedulleOpen;
    work;
    sale;
    minutes;
    
    constructor() {
        
        this.isOpen = false;
        this.isSaleSchedulleOpen = false;
        this.work = {};
        this.sale = {};
        this.minutes = '';

        makeObservable(this, {
            isOpen: observable,
            isSaleSchedulleOpen: observable,
            work: observable,
            sale: observable,
            minutes: observable,

            isSchedulleEditDialogOpen: computed,
            isSaleSchedulleEditDialogOpen: computed,
            getWork: computed,
            getSale: computed,
            getMinutes: computed,

            openSchedulleEditDialog: action,
            openSaleSchedulleEditDialog: action,
            closeSchedulleEditDialog: action,
            closeSaleSchedulleEditDialog: action,
            setWork: action,
            setSale: action,
            setMinutes: action,
        });
    }

    get isSchedulleEditDialogOpen() {
        return this.isOpen;
    }

    get isSaleSchedulleEditDialogOpen() {
        return this.isSaleSchedulleOpen;
    }

    get getWork() {
        return this.work;
    }

    get getSale() {
        return this.sale;
    }

    get getMinutes() {
        return this.minutes;
    }
    
    setWork(work) {
        this.work = work;
    }

    setSale(sale) {
        this.sale = sale;
    }

    setMinutes(minutes) {
        this.minutes = minutes;
    }

    openSchedulleEditDialog(work, minutes) {
        this.work = work;
        this.minutes = minutes;
        this.isOpen = true;
    }

    openSaleSchedulleEditDialog(sale, minutes) {
        this.sale = sale;
        this.minutes = minutes;
        this.isSaleSchedulleOpen = true;
    }

    closeSchedulleEditDialog() {
        this.work = {};
        this.isOpen = false;
        this.minutes = '';
    }

    closeSaleSchedulleEditDialog() {
        this.sale = {};
        this.isSaleSchedulleOpen = false;
        this.minutes = '';
    }
}

const schedulleStore = new SchedulleStore();

export default schedulleStore;
export { SchedulleStore };